import { CheckCircle2, AlertTriangle, XCircle } from 'lucide-react';

export default function StatusBadge({ score, size = 'medium' }) {
    const getConfig = () => {
        if (score >= 90) return { color: 'emerald', icon: CheckCircle2 };
        if (score >= 75) return { color: 'blue', icon: CheckCircle2 };
        if (score >= 50) return { color: 'amber', icon: AlertTriangle };
        return { color: 'red', icon: XCircle };
    };

    const config = getConfig();
    const Icon = config.icon;
    const sizeClass = size === 'small' ? 'text-sm px-3 py-1' : 'text-lg px-6 py-3';

    return (
        <div className={`
      ${sizeClass} rounded-2xl font-bold shadow-sm border flex items-center gap-3
      bg-${config.color}-50 text-${config.color}-700 border-${config.color}-200
    `}>
            <div className={`p-1 rounded-full bg-${config.color}-100`}>
                <Icon size={size === 'small' ? 14 : 16} className={`text-${config.color}-600`} />
            </div>
            {score}%
        </div>
    );
}
